// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const philid: CountryValidator<"PH"> = createValidator(
  "ph.philid",
  143,
);

export default philid;
export const compact = philid.compact;
export const format = philid.format;
export const validate = philid.validate;
export const generate = (): string =>
  philid.generate?.() ??
  (() => {
    throw new Error(
      "Validator ph.philid cannot generate values",
    );
  })();
